var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 58,
    viewBox: "0 0 88 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7207 57.9975L60.1599 57.4919C60.1599 57.4919 88.2603 57.2391 87.9982 28.4998C87.736 -0.239433 59.6357 6.43652e-05 59.6357 6.43652e-05L7.19644 0.505669C3.18585 0.598806 -0.0645588 3.87188 0.000973817 8.03642L0.407273 50.7329C0.407273 54.7644 3.72322 58.104 7.73382 57.9975H7.7207Z",
    fill: "#5C42FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8911 24.0693H19.9619V30.7885C19.9619 32.3984 20.9318 33.4628 22.5308 33.4628C24.1298 33.4628 25.0997 32.3984 25.0997 30.7885V24.0693H27.1705V30.9348C27.1705 33.4761 25.506 35.4852 22.5308 35.4852C19.5556 35.4852 17.8911 33.4761 17.8911 30.9348V24.0693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8324 24.0693V35.2457H30.7354V24.0693H32.8324Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4436 23.3779H43.6323L37.7868 36.111H35.585L41.4436 23.3779Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.293 24.0693H48.3638V30.7885C48.3638 32.3984 49.3337 33.4628 50.9327 33.4628C52.5317 33.4628 53.5016 32.3984 53.5016 30.7885V24.0693H55.5724V30.9348C55.5724 33.4761 53.9079 35.4852 50.9327 35.4852C47.9575 35.4852 46.293 33.4761 46.293 30.9348V24.0693Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1674 24.0693H60.6314L63.2921 27.9678L65.9265 24.0693H68.4036L64.8387 29.3648L68.7575 35.2324H66.241L63.2921 30.8417L60.3431 35.2324H57.8267L61.7455 29.3648L58.1805 24.0693H58.1674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiux);
export default __webpack_public_path__ + "static/media/uiux.db365212e2877bd633d6308792829dd0.svg";
export { ForwardRef as ReactComponent };